import React, { useEffect, useRef, useState } from 'react'
import styles from './Navbar.module.css'
import { smoothScrollTo } from '../../assets/utils/smoothScroll';
import { useNavigate } from 'react-router-dom';
import IconComponent from '../IconComponent/IconComponent';
import { FaArrowUp } from 'react-icons/fa'
import { HoverState } from '../../assets/utils/cursorTypes';

export type NavbarProps = {
    navOpened: boolean;
    setNavOpened: React.Dispatch<React.SetStateAction<boolean>>;
    currentLink: string;
    setHoverElement: React.Dispatch<React.SetStateAction<HoverState>>;
    navbarRef: React.RefObject<HTMLDivElement | null>;
}

const Navbar = (props: NavbarProps) => {

    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const navigate = useNavigate();

    const handleScroll = (target: string) => {
        const targetElement = document.getElementById(target.toString());
        if (targetElement) {
            props.setNavOpened(false);
            const navbarHeight = target !== 'home' ? 0 : props.navbarRef.current?.offsetHeight || 0;
            const offsetTop = targetElement.offsetTop - navbarHeight;
            smoothScrollTo(offsetTop, 800);
        }
    };

    useEffect(() => {
        const onScroll = () => {
            const currentScrollY = window.scrollY;
        
            if (currentScrollY > lastScrollY && currentScrollY > 0) {
                setIsVisible(false); // Scrolling down
            } else {
                setIsVisible(true); // Scrolling up
            }
        
            setLastScrollY(currentScrollY);
        };
    
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, [lastScrollY]);

    const navLinkScroll = (target: string) => {
        if(window.location.pathname === '/'){
            handleScroll(target);
        }else{
            navigate(`/#${target}`);
        }
    }

    return (
        <div 
            className={`${styles.container} ${!isVisible && !props.navOpened ? styles.hidden : ''}`}
            ref={props.navbarRef}    
        >
            <div 
                className={styles.logo} 
                onClick={() => navigate("")}
                onMouseEnter={() => props.setHoverElement('pointer')}
                onMouseLeave={() => props.setHoverElement('normal')}
            >Jorge Vieira/</div>
            <div className={styles.menu}>
                <div 
                    className={styles.menuLogo} 
                    onClick={() => props.setNavOpened(!props.navOpened)}
                    onMouseEnter={() => props.setHoverElement('pointer')}
                    onMouseLeave={() => props.setHoverElement('normal')}
                ></div>
                <div className={`${styles.nav_items} ${props.navOpened ? styles['nav_items--active'] : ''}`}>
                    <div className={styles.items}>
                        <div className={styles.nav_header}>
                            <div 
                                className={styles.logo} 
                                onClick={() => navigate('')}
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >Jorge Vieira/</div>
                            <div 
                                className={styles.closeNav} 
                                onClick={() => props.setNavOpened(false)}
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >
                                <div className={styles.closeLine1}></div>
                                <div className={styles.closeLine2}></div>
                            </div>
                            <button 
                                className={styles.btn_contact} 
                                onClick={() => navLinkScroll('contact')}
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >
                                <span>Contact</span>
                                <span>&nbsp;Now</span>
                            </button>
                        </div>
                        <div className={styles.nav_links}>
                            <h2 
                                onClick={() => navigate('')} 
                                className={`${props.currentLink === '' && styles.active}`}
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >
                                HOME
                            </h2>
                            <h2 
                                onClick={() => navLinkScroll('about')} 
                                className={`${props.currentLink === '/about' && styles.active}`}
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >
                                ABOUT
                            </h2>
                            <h2 
                                onClick={() => navLinkScroll('experience')} 
                                className={`${props.currentLink === '/experience' && styles.active}`}
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >
                                EXPERIENCE
                            </h2>
                            <h2 
                                onClick={() => navLinkScroll('projects')} 
                                className={`${props.currentLink === '/projects' && styles.active}`}
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >
                                PROJECTS
                            </h2>
                            <h2 
                                onClick={() => navLinkScroll('contact')} 
                                className={`${props.currentLink === '/contact' && styles.active}`}
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >
                                CONTACT
                            </h2>
                        </div>
                        <div className={styles.nav_social}>
                            <a 
                                href="https://www.linkedin.com/in/jorgevieira18/" 
                                target='_blank' 
                                rel="noreferrer"
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >
                                <span>LinkedIn</span>
                                <span className={styles.icon_social}><IconComponent icon={FaArrowUp} size={15} /></span>
                            </a>
                            <a 
                                href="https://github.com/JorgeFMVieira" 
                                target='_blank' 
                                rel="noreferrer"
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >
                                <span>GitHub</span>
                                <span className={styles.icon_social}><IconComponent icon={FaArrowUp} size={15} /></span>
                            </a>
                            <a 
                                href="https://www.instagram.com/jorgev018/" 
                                target='_blank' 
                                rel="noreferrer"
                                onMouseEnter={() => props.setHoverElement('pointer')}
                                onMouseLeave={() => props.setHoverElement('normal')}
                            >
                                <span>Instagram</span>
                                <span className={styles.icon_social}><IconComponent icon={FaArrowUp} size={15} /></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <button 
                className={styles.btn_contact} 
                onClick={() => navLinkScroll('contact')}
                onMouseEnter={() => props.setHoverElement('pointer')}
                onMouseLeave={() => props.setHoverElement('normal')}
            >
                <span>Contact</span>
                <span>&nbsp;Now</span>
            </button>
        </div>
    )
}

export default Navbar
